require("./blocks/");

module.exports = require("./compiler/compiler.js");
